import { submitSteps } from "@/mocks/homeData";

export default function SubmitGuide() {
  return (
    <section id="submit" className="w-full bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-accent-700 bg-accent-100 px-3 py-1 rounded-full">
            <i className="ri-upload-cloud-2-line"></i>
            <span>投稿爆料流程</span>
          </div>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold tracking-tight text-foreground-950">
            四步走完，材料就交到官方手上
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
            不需要实名，也不用担心材料外泄。把线索整理清楚，
            剩下的交给官方的核对流程就好。
          </p>
        </div>

        <div className="mt-8 md:mt-12 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-stretch">
          <div className="lg:col-span-5">
            <div className="relative h-64 sm:h-80 lg:h-full min-h-[260px] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20anonymous%20information%20submission%2C%20stylized%20folder%20shield%20and%20envelope%20icons%20with%20warm%20orange%20and%20green%20accents%20on%20dark%20charcoal%20background%2C%20abstract%20geometric%20shapes%2C%20clean%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=1000&height=800&seq=hl-guide-01&orientation=landscape"
                alt="黑料官方投稿爆料流程示意图"
                title="黑料官方 投稿爆料 流程"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <div className="flex items-center gap-2 text-xs md:text-sm text-background-100">
                  <i className="ri-lock-2-line text-accent-300"></i>
                  <span>材料加密保存 · 支持匿名提交</span>
                </div>
                <p className="mt-2 font-heading text-lg md:text-xl font-bold text-background-50">
                  爆料信息不对外公开原文
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {submitSteps.map((item) => (
              <div
                key={item.step}
                className="flex flex-col rounded-lg border border-background-200/80 bg-background-50 p-5 md:p-6 hover:border-primary-200 transition-colors"
              >
                <span className="font-heading text-3xl md:text-4xl font-black text-primary-300">{item.step}</span>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
            <div className="sm:col-span-2 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 rounded-lg border border-primary-200 bg-primary-50 p-5 md:p-6">
              <div>
                <p className="font-heading text-base md:text-lg font-bold text-foreground-950">准备好材料了？</p>
                <p className="mt-1 text-xs md:text-sm text-foreground-700">
                  直接投给官方投稿邮箱：tip@heiliaoguanfang.com
                </p>
              </div>
              <a
                href="#contact"
                className="shrink-0 inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-4 md:px-5 py-2.5 rounded-md whitespace-nowrap transition-colors cursor-pointer"
              >
                <i className="ri-send-plane-fill"></i>
                <span>去投稿</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}